import React from "react";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { RichTooltipPopover } from "../../../../SharedComponents/RichTooltipPopover";

const useStyles = makeStyles((theme) => ({}));

const GraphTitle = ({ text, tooltip }) => {
  const classes = useStyles();
  return (
    <Box component="header" sx={{ display: "flex", alignItems: "center" }}>
      <Typography variant="subtitle1">{text}</Typography>
      <RichTooltipPopover name={text} body={tooltip} />
    </Box>
  );
};

export default GraphTitle;
